import React from 'react';
import {brand} from '../brand';

export const PageDots: React.FC<{count: number; activeIndex: number}> = ({
  count,
  activeIndex,
}) => (
  <div style={{display: 'flex', gap: 12, alignItems: 'center'}}>
    {Array.from({length: count}).map((_, i) => {
      const active = i === activeIndex;
      return (
        <div
          key={i}
          style={{
            width: active ? 36 : 12,
            height: 12,
            borderRadius: 999,
            background: active ? brand.primary : 'rgba(255,255,255,0.2)',
          }}
        />
      );
    })}
  </div>
);
